module.exports = __webpack_public_path__ + "media/assets/img/company/Logo Skillsoft-baa92111ed9659bd9ba92d0c7edfba6a.png";